import type { BeckyFunctionLibrary, BeckyModel, BeckyRequestPayload } from '@wix/thunderbolt-becky-root'
import { getViewerCatharsisCss } from '@wix/thunderbolt-catharsis-deployable'
import type { Logger } from '@wix/thunderbolt-becky-types'
import schemas from '@wix/document-services-json-schemas/dist/refData.json'
import { getViewerStateManagerCss } from '@wix/thunderbolt-css'
import { shouldReturnCssObject, shouldRunVsmFromPayload } from './cssModuleUtils'
import _ from 'lodash'

export const getCatharsisCss = (
	payload: BeckyRequestPayload,
	funcLib: BeckyFunctionLibrary,
	beckyModel: BeckyModel,
	logger: Logger
) => {
	const runAndReport = <T>(fn: () => T, name: string) => {
		const dateBefore = Date.now()
		const res = fn()
		const dateAfter = Date.now()
		logger.info(name, { duration: dateAfter - dateBefore })
		return res
	}

	const shouldRunVsm = shouldRunVsmFromPayload(payload)
	if (payload.module === 'builder-component-css') {
		beckyModel.pageCompId =
			_.find(beckyModel.structure, (comp) => comp.componentType.includes('AppWidget'))?.id ??
			beckyModel.pageCompId
	}
	const cssResponse = funcLib.runAndReport(
		() =>
			shouldRunVsm
				? getViewerStateManagerCss(beckyModel, runAndReport)
				: getViewerCatharsisCss(beckyModel, schemas, runAndReport),
		shouldRunVsm ? 'get-vsm-css' : 'get-catharsis-css'
	)

	const cssResultObject: typeof cssResponse['css'] = shouldReturnCssObject(payload) ? cssResponse.css : {}

	const catharsisCss = cssResponse.cssResult as string
	return {
		catharsisCss,
		cssResultObject,
	}
}
